// ATG Loyalty Service
var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("loyaltyService", [
    "$http",
    function ($http) {
        return {
            getCustomerLoyaltyProfile: function () {
                return $http.get(
                    "storefrontapi/embroidery-loyalty/customer-loyalty-profile"
                );
            },
            redeemPoints: function (loyaltyPoints) {
                return $http.get(
                    "storefrontapi/embroidery-loyalty/redeem/" + loyaltyPoints
                );
            },
            getOrderLoyaltyPoints: function (orderNumber) {
                return $http.get(
                    "storefrontapi/embroidery-loyalty/getorderpoints/" + orderNumber
                );
            },
            getTransactionHistory: function (filterParams) {
                return $http.post(
                    "storefrontapi/embroidery-loyalty/customer-loyalty-transaction-history",
                    filterParams
                );
            },
            getLoyaltyContent: function () {
                return $http.get("storefrontapi/embroidery-loyalty/content");
            },
            getCustomerLoyaltyInfo: function () {
                return $http.get('storefrontapi/customerloyalty/getcustomerloyaltyinfo');
            }
        };
    },
]);
